const NAME = "DISTRIBUTION_COST";

export default NAME;
